import { useState, useEffect } from "react";
import FlowFieldCanvas from "./FlowFieldCanvas";

const CutSceneTransition = ({ config, onComplete }) => {
  const [phase, setPhase] = useState("enter"); // enter -> hold -> exit

  const isFinal = config?.isFinal || false;

  useEffect(() => {
    if (!config) return;
    setPhase("enter");

    // Animate to hold phase, then stay - user clicks Next to advance
    const holdTimer = setTimeout(() => setPhase("hold"), 400);

    return () => {
      clearTimeout(holdTimer);
    };
  }, [config]);

  if (!config) return null;

  return (
    <div className={`et-cutscene et-cutscene--${phase}`}>
      <FlowFieldCanvas />

      {/* Center content */}
      <div className="et-cutscene__center">
        <h2 className="et-cutscene__headline">{config.headline}</h2>
        <p className="et-cutscene__subline">{config.subline}</p>

        {isFinal && (
          <div className="et-cutscene__final">
            <p className="et-cutscene__final-text">The buy side of the MLS.</p>
          </div>
        )}
      </div>

      {/* Subtle progress dots at bottom */}
      <div className="et-cutscene__indicator">
        <div
          className={`et-cutscene__indicator-dot ${phase !== "enter" ? "et-cutscene__indicator-dot--active" : ""}`}
        />
      </div>
    </div>
  );
};

export default CutSceneTransition;
